<!--
 * @Descripttion: 终端人员签约策略卡（向日葵服务助手专用，仅终端人员合同 tab 渲染）
 *   单行：[开关] 签署终端人员合同 [badge] [模版名称]   [合同模版] [自动签署]
 *   - badge：开启=「需签署」，关闭=「免签署」
-->
<template>
  <div class="terminal-strategy-card" v-xrk-loading="loading">
    <div class="terminal-strategy-card__main">
      <BaseSwitch
        :active-value="1"
        :inactive-value="0"
        v-model="strategy.signTerminalContract"
        :before-change="
          async () => {
            await onToggleTerminal(strategy);
          }
        "
      />
      <span class="terminal-strategy-card__label">签署终端人员合同</span>
      <BaseTag
        effect="plain"
        :type="signTerminalOn ? 'warning' : 'danger'"
        class="terminal-strategy-card__badge"
      >
        {{ signTerminalOn ? '需签署' : '免签署' }}
      </BaseTag>
      <BaseInput
        disabled
        :model-value="strategy.marketServicePersonTemplate.contractTemplateName"
      />
    </div>

    <div class="terminal-strategy-card__actions">
      <BaseButton type="default" @click="emits('go-template')">
        <BaseIcon size="14" style="margin-right: 4px">
          <Document />
        </BaseIcon>
        合同模版
      </BaseButton>
      <BaseButton
        :type="!strategy.isAutoSign ? 'primary' : 'default'"
        class="auto-sign-btn"
        :class="{ 'auto-sign-btn--on': strategy.isAutoSign }"
        :loading="autoSignSaving"
        :click="onToggleAutoSign"
      >
        <span class="auto-sign-btn__dot" />
        自动签署
        <span class="auto-sign-btn__state">
          {{ !strategy.isAutoSign ? '已开启' : '未开启' }}
        </span>
      </BaseButton>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { computed, onMounted, ref } from 'vue';
import {
  BaseSwitch,
  BaseButton,
  BaseIcon,
  BaseTag,
  BaseInput,
  XrkMessage
} from 'xrk-components';
import { Document } from '@element-plus/icons-vue';

import {
  getTerminalSignStrategy,
  saveTerminalSignStrategy,
  type TerminalSignStrategy
} from '../data-source/apis';

const emits = defineEmits<{ (e: 'go-template'): void }>();

const DEFAULT_STRATEGY: TerminalSignStrategy = {
  signTerminalContract: null,
  isAutoSign: 0,
  marketServicePersonTemplate: {
    id: 0,
    contractTemplateName: ''
  }
};

const strategy = ref<TerminalSignStrategy>({ ...DEFAULT_STRATEGY });
const loading = ref(false);
const autoSignSaving = ref(false);

const signTerminalOn = computed(() => !!strategy.value.signTerminalContract);

/** 拉取签约策略 */
const fetchStrategy = async () => {
  loading.value = true;
  try {
    const { data } = await getTerminalSignStrategy();
    strategy.value = { ...DEFAULT_STRATEGY, ...data };
  } finally {
    loading.value = false;
  }
};

onMounted(fetchStrategy);

/** 开关：签署终端人员合同 */
const onToggleTerminal = async strategy => {
  console.log(strategy, 'vvvv');
  return new Promise((resolve, reject) => {
    saveTerminalSignStrategy({
      signTerminalContract: +!strategy.signTerminalContract as 0 | 1
    })
      .then(() => {
        XrkMessage.success(
          +!strategy.signTerminalContract
            ? '已开启签署终端人员合同'
            : '已关闭签署终端人员合同'
        );
        resolve(true);
      })
      .catch(() => {
        reject(false);
      });
  });
};

/** 自动签署切换 */
const onToggleAutoSign = async () => {
  const next = strategy.value.isAutoSign ? 0 : 1;
  await saveTerminalSignStrategy({ isAutoSign: next });
  XrkMessage.success(!next ? '已开启自动签署' : '已关闭自动签署');
  strategy.value.isAutoSign = next;
};

defineExpose({
  refresh: fetchStrategy
});
</script>

<style lang="scss" scoped>
.terminal-strategy-card {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 12px;
  margin: 0 0 12px;
  border-radius: 6px;
  background: transparent;
  transition: background 0.2s ease, box-shadow 0.2s ease;

  &--alert {
    background: #fef2f2;
    box-shadow: 0 0 0 1px #fecaca inset;
  }

  &__main {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  &__label {
    font-size: 14px;
    color: #121619;
  }
  &__badge {
    margin-right: 4px;
  }
  &__select {
    width: 240px;
  }
  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
}

.auto-sign-btn {
  position: relative;
  &__dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #d1d5db;
    margin-right: 6px;
    vertical-align: middle;
  }
  &--on .auto-sign-btn__dot {
    background: #fff;
  }
  &__state {
    margin-left: 4px;
    opacity: 0.85;
  }
}
</style>
